// eslint-disable-next-line no-shadow
export var E_ALERT;
(function (E_ALERT) {
    E_ALERT["INFO"] = "info";
    E_ALERT["SUCCESS"] = "success";
    E_ALERT["DANGER"] = "warning";
    E_ALERT["ERROR"] = "error";
    E_ALERT["WARNING"] = "warning";
})(E_ALERT || (E_ALERT = {}));
